import { signIn, SignInAuthorizationParams, SignInOptions } from 'next-auth/react';
import { TreatmentWithConfig } from '@splitsoftware/splitio/types/splitio';
import { setSessionStorageItem } from 'src/services/storage/session';
import {
    ActiveSplitExperiment,
    FEATURE_FLAG_STATUS,
    SPLIT_EXPERIMENTS,
} from 'src/services/experiments/client/ongoingExperiments';
import { deferredDatadog } from 'src/services/datadog/deferred';
import { CUSTOM_ACTIONS } from 'src/services/datadog/constants';
import { AUTH_EVENT_TYPES } from '../../../../events/constants';
import { dispatch } from '../../../../events/dispatch';
import {
    LOCATION_REQUESTED_SESSION_STORAGE_KEY,
    SUPPORTED_LOGIN_FLAG,
    ENABLE_OTP_LOGIN,
    AUTH0_IDP_IDENTIFIER,
    AUTH0_IDP_IDENTIFIER_KEY,
} from './constants';
import { getAppropriateProvider } from './utils/getAppropriateProvider';

export const zillowSignIn = async (
    experiments: Record<ActiveSplitExperiment, TreatmentWithConfig | null>,
    options?: SignInOptions
) => {
    dispatch(AUTH_EVENT_TYPES.LOGIN);
    const auth0Experiment = experiments[SPLIT_EXPERIMENTS.HOME_LOANS_DASHBOARD_AUTH_MIGRATION];
    const isAuth0Active = !!auth0Experiment && auth0Experiment.treatment === FEATURE_FLAG_STATUS.ON;
    await deferredDatadog.addAction(CUSTOM_ACTIONS.AUTHENTICATION_START);
    const provider = getAppropriateProvider(experiments);
    setSessionStorageItem(LOCATION_REQUESTED_SESSION_STORAGE_KEY, window.location.pathname);
    const signInOptions: SignInAuthorizationParams = {
        [SUPPORTED_LOGIN_FLAG]: ENABLE_OTP_LOGIN,
    };
    if (isAuth0Active) {
        // eslint-disable-next-line import/dynamic-import-chunkname
        const { getAuth0QueryParams } = await import('@zillow/universal-analytics');
        const auth0QueryParams = await getAuth0QueryParams();
        signInOptions[auth0QueryParams.key] = auth0QueryParams.value;
        signInOptions[AUTH0_IDP_IDENTIFIER_KEY] = AUTH0_IDP_IDENTIFIER;
    }
    setTimeout(() => {
        // defer sign-in long enough for the dispatch to propagate
        signIn(provider, options, signInOptions);
    }, 250);
};
